import { css } from "@emotion/css";
import React from "react";

import { useColors } from "../../../../hooks/useColors";
import { useGetAllFocusShadows } from "../../../utils";

export interface InputCardProps {
  children: React.ReactNode;
  isChecked?: boolean;
  isDisabled?: boolean;
  testID?: string;
}

export function InputCard(props: InputCardProps) {
  const colors = useColors();
  const { children, isChecked, isDisabled, testID = "input-card" } = props;
  const boxShadow = `inset 0 0 0 1px ${
    isChecked ? colors["border-input-active"] : colors["border-base"]
  }`;
  const getAllFocusShadows = useGetAllFocusShadows();

  return (
    <label
      className={css(
        styles.card,
        isDisabled
          ? css({
              boxShadow: `inset 0 0 0 1px ${colors["border-input-disabled"]}`,
              cursor: "not-allowed",
            })
          : css({
              backgroundColor: colors["background-input"],
              "&:focus-within": getAllFocusShadows(boxShadow),
              boxShadow,
            })
      )}
      data-testid={testID}
    >
      {children}
    </label>
  );
}

const styles = {
  card: css({
    flex: 1,
    display: "flex",
    alignItems: "center",
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    padding: "var(--space-3)",
    borderRadius: "var(--border-radius-3)",
  }),
};
